<template>
    <div class="row row--15 service-wrapper">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12"
             v-for="(service, index) in serviceList"
             :key=index>
            <div :class="`service ${serviceStyle} ${checkTextAlign}`"
                 data-aos="fade-up"
                 data-aos-delay="70">
                <div class="icon">
                    <Icon :name="service.icon" :class="`size-${iconSize}`"/>
                </div>
                <div class="content">
                    <h4 class="title w-600">
                        <router-link to="/service-details" v-html="service.title"/>
                    </h4>
                    <p class="description b1 color-gray mb--0" v-html="service.description"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../../icon/Icon'

    export default {
        name: 'ServiceOne',
        components: {Icon},
        props: {
            serviceStyle: {
                type: String
            },
            iconSize: {
                type: String|Number,
                default: 62
            },
            textAlign: {
                type: String,
                default: 'left'
            }
        },
        data() {
            return {
                serviceList: [
                    {
                        icon: 'activity',
                        title: 'Domain-Specific Solutions',
                        description: 'For the past several years, the Algoscale front-end team has been developing custom web apps ranging from small-scale projects to enterprise-level commercial solutions.'
                    },
                    {
                        icon: 'cast',
                        title: 'Front-End Development',
                        description: 'We design applications that are engaging, intuitive, and conversion-driven and  provide customers with a consistent source of revenue while also providing enjoyment to users.'
                    },
                    {
                        icon: 'map',
                        title: 'Custom Software Development',
                        description: 'We provide Angular web development services that are tailored to the individual needs of each customer, ensuring that their expectations are fulfilled and exceeded.'
                    },
                ]
            }
        },
        computed: {
            checkTextAlign() {
                if (this.textAlign === 'left') return 'text-start';
                else if (this.textAlign === 'center') return 'text-center';
                else if (this.textAlign === 'end') return 'text-end';
                else return '';
            }
        }
    }
</script>